import ClassroomTable from "./ClassroomTable";
import TableSkeleton from "../../../common/TableSkeleton";
import TableError from "../../../common/TableError";
import { ITEMS_PER_PAGE } from "../../../../../constant/constant";

/**
 * @typedef {import("../../../../../hooks/teacher/classroom/useGetClassroomById").StudentType} StudentType
 */

/**
 * @typedef {Object} AllStudentsTabProps
 * @property {StudentType[]} students - Array of student objects
 * @property {boolean} loading - Loading state
 * @property {string} error - Error message
 * @property {function} handleRefresh - Refresh handler function
 * @property {"school-admin" | "teacher"} type - Type of user
 */

/**
 * AllStudentsTab component displays all students in the classroom
 * @param {AllStudentsTabProps} props
 * @returns {JSX.Element}
 */
const AllStudentsTab = ({ students, loading, error, handleRefresh, type }) => {
  // Show skeleton on initial load (when loading and no students yet)
  if (loading && (!students || students.length === 0)) {
    return <TableSkeleton rows={ITEMS_PER_PAGE} columns={4} />;
  }

  // Show error state
  if (error) {
    return <TableError error={error} handleRefresh={handleRefresh} loading={loading} />;
  }

  // Show empty state
  if (!students || students.length === 0) {
    return (
      <div className="alert alert-info mt-3" role="alert">
        No students found in this classroom.
      </div>
    );
  }

  return (
    <div>
      <ClassroomTable students={students} type={type} />
    </div>
  );
};

export default AllStudentsTab;
